import axios, { AxiosResponse } from 'axios';
import { PaginatedResponse } from '../@types/common';

export enum GroupType {
  DRAFT = 'draft',
  ACTIVE = 'active',
  INACTIVE = 'inactive'
}

export type LogoAction = 'UPDATE' | 'KEEP' | 'DELETE';

export type Group = {
  _id: string;
  name: string;
  planNumber: string;
};

export type DraftList = PaginatedResponse<Group>;

export interface MemberGroup {
  id: number | string;
  name: string;
}

export type FormData = {
  [key: string]: string | Array<FormData>;
};

export type LogoData = {
  action: LogoAction;
  image: string | null;
};

export const publicAxios = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL
});

export async function fetchReports() {
  const resp: AxiosResponse = await publicAxios.get('/reports');
  return resp.data;
}
